import React,{useState, useRef} from 'react'
import Title from '../layouts/Title';
import ContactLeft from './ContactLeft';
import emailjs from '@emailjs/browser';
import { useTheme } from '../theme/ThemeContext';


const Contact = () => {
  const {darkTheme} = useTheme();
  const [errMsg, setErrMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const usernameRef = useRef(null);
  const emailRef = useRef(null);
  const messageRef = useRef(null);
  const phoneRef = useRef(null);
  const form = useRef(null);


  const sendEmail = (e) => {
    const username = usernameRef.current.value;
    const email = emailRef.current.value;
    const message = messageRef.current.value;
    const phone = phoneRef.current.value;
    e.preventDefault();

     
      if (!username) {
        setErrMsg("Username is required!");
      } else if (!email) {
        setErrMsg("Please give your Email!");
      } else if (!emailValidation(email)) {
        setErrMsg("Give a valid Email!");
      } else if (!message) {
        setErrMsg("Message is required!");
      } else if (!phone) {
        setErrMsg("Please enter your phone number");
      }else {
        emailjs.sendForm('service_jht9atj',
        'template_0pryg3g',
         form.current, 'DNpxETwynQjE6VFUe')
        .then((result) => {
            console.log(result.text);
            console.log('message sent');
            setSuccessMsg(`Thank you dear ${username}, Your Messages has been sent Successfully!`);
        }, (error) => {
            console.log(error.text);
        });
        setErrMsg("");
  
        usernameRef.current.value = "";
        emailRef.current.value = "";
        messageRef.current.value = "";
        phoneRef.current.value = "";
      }
  };


  
  const emailValidation = () => {
    return String(emailRef.current.value)
      .toLocaleLowerCase()
      .match(/^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/);
  };
  


  return (
    <section id="contact" className="w-full py-20 border-b-[1px] border-b-black">
      <div className="flex justify-center items-center text-center">
        <Title title="CONTACT" des="Contact With Me" />
      </div>
      <div className="w-full">
        <div className="w-full h-auto flex flex-col lgl:flex-row justify-between">
          <ContactLeft />
          <div className={darkTheme?"w-full lgl:w-[60%] h-full py-10 bg-gradient-to-r from-bodyColor to-[gray] flex flex-col gap-8 p-4 lgl:p-8 rounded-lg "
          :"w-full lgl:w-[60%] h-full py-10 bg-gradient-to-r from-grayBodyColor to-[gray] flex flex-col gap-8 p-4 lgl:p-8 rounded-lg "}>
            <form ref={form} onSubmit={sendEmail} className="w-full flex flex-col gap-4 lgl:gap-6 py-2 lgl:py-5">
              {errMsg && (
                <p className="py-3 bg-gradient-to-r from-bodyColor to-[#23272b]  text-center text-red-500 text-base tracking-wide animate-bounce">
                  {errMsg}
                </p>
              )}
              {successMsg && (
                <p className="py-3 bg-gradient-to-r from-[#1e2024] to-[#23272b] shadow-shadowOne text-center text-green-500 text-base tracking-wide animate-bounce">
                  {successMsg}
                </p>
              )}
              <div className="w-full flex flex-col lgl:flex-row gap-10">
                <div className="w-full lgl:w-1/2 flex flex-col gap-4">
                  <p className={darkTheme?"text-sm text-gray-400 uppercase tracking-wide"
                  :"text-black text-black-400 uppercase tracking-wide"}>
                    Your name
                  </p>
                  <input
                    name="name"
                    ref={usernameRef}
                    className={darkTheme?`${
                      errMsg === "Username is required!" && "outline-red"
                    } contactInput`:`${
                      errMsg === "Username is required!" && "outline-red"
                    } contactInput2`}
                    type="text"
                  />
                </div>
              </div>
              <div className="flex flex-col gap-4">
                <p className={darkTheme?"text-sm text-gray-400 uppercase tracking-wide"
                :"text-black text-black-400 uppercase tracking-wide"}>
                  Phone Number
                </p>
                <input
                  name="phone"
                  ref={phoneRef}
                  className={darkTheme?`${
                    errMsg === "Please give your Phone Number!" && "outline-red"
                  } contactInput`:`${
                    errMsg === "Please give your Phone Number!" && "outline-red"
                  } contactInput2`}
                  type="text"
                />
              </div>
              <div className="flex flex-col gap-4">
              <p className={darkTheme?"text-sm text-gray-400 uppercase tracking-wide"
                :"text-black text-black-400 uppercase tracking-wide"}>
                Email
                </p>
                <input
                  name="email"
                  ref={emailRef}
                  className={darkTheme?`${
                    errMsg === "Please give your Email!" && "outline-red"
                  } contactInput`:`${
                    errMsg === "Please give your Email!" && "outline-red"
                  } contactInput2`}
                  type="email"
                />
              </div>
              <div className="flex flex-col gap-4">
              <p className={darkTheme?"text-sm text-gray-400 uppercase tracking-wide"
                :"text-black text-black-400 uppercase tracking-wide"}>
                Message
                </p>
                <textarea
                  name="message"
                  ref={messageRef}
                  className={darkTheme?`${
                    errMsg === "Message is required!" && "outline-red"
                  } contactTextArea`:`${
                    errMsg === "Message is required!" && "outline-red"
                  } contactTextArea2`}
                  cols="30"
                  rows="8"
                ></textarea>
              </div>
              <div className="w-full">
                <input
                  type="submit"
                  value="Send"
                  className="w-full h-12 bg-[#eee] rounded-lg text-base text-gray-400 tracking-wider uppercase hover:text-white duration-300 hover:border-[1px] hover:border-designColor border-transparent"
                />
              </div>
              {errMsg && (
                <p className="py-3 bg-gradient-to-r from-[#1e2024] to-[#23272b] shadow-shadowOne text-center text-orange-500 text-base tracking-wide animate-bounce">
                  {errMsg}
                </p>
              )}
              
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}


export default Contact;